// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__3lHm_","Description":"Section_Description__3n48X","Organizer":"Section_Organizer__14v3M"};